import Layout from "@/components/feature/Layout";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ArticleList from "./components/ArticleList";
import TrendingSection from "./components/TrendingSection";
import SubscribeSection from "./components/SubscribeSection";
import JsonLd from "@/components/base/JsonLd";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "妈妈的朋友2 影迷资讯站",
  url: "https://showpath4.github.io/",
  description: "致力于为影迷提供「妈妈的朋友2」最全面的剧情解析、演员阵容介绍、观看指南和影评点评。",
  inLanguage: "zh-CN",
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "妈妈的朋友2 影迷资讯站",
  url: "https://showpath4.github.io/",
  description: "致力于为影迷提供「妈妈的朋友2」最全面的剧情解析、演员阵容介绍、观看指南和影评点评。",
  foundingDate: "2025",
};

export default function Home() {
  return (
    <Layout>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <HeroSection />
      <CategorySection />
      <TrendingSection />
      <ArticleList />
      <SubscribeSection />
    </Layout>
  );
}